import { useCallback } from 'react';
import {
    getAllComponents as getAllComponentsApi,
    getComponent as getComponentApi,
    updateComponent as updateComponentApi,
    createComponent as createComponentApi,
    deleteComponent as deleteComponentApi,
} from '../api/Prompt'
import { PromptComponent } from '@common/domain/types';
import { useUserInfoContext } from '../contexts/UserInfoContext';

export const usePrompt = () => {
    const { userInfo } = useUserInfoContext()

    const getAllComponents = useCallback(async () => {
        try {
            return await getAllComponentsApi(userInfo);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    const getComponent = useCallback(async (type: string, id: string) => {
        try {
            return await getComponentApi(userInfo, type, id);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    const updateComponent = useCallback(async (type: string, id: string, updates: Partial<PromptComponent>) => {
        try {
            return await updateComponentApi(userInfo, type, id, updates);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    const createComponent = useCallback(async (component: PromptComponent) => {
        try {
            return await createComponentApi(userInfo, component);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    const deleteComponent = useCallback(async (type: string, id: string) => {
        try {
            return await deleteComponentApi(userInfo, type, id);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    return {
        getAllComponents,
        getComponent,
        updateComponent,
        createComponent,
        deleteComponent
    }
}
